<template>
  <div class="row">
    <div v-for="(register, index) in list" :key="index" class="col-md-4 mb-4">
      <div class="p-4 bg-white rounded">
        <div class="d-flex justify-content-between">
          <div>
            <div class="label">
              {{ register.info.name.label
              }}<span v-if="register.info.status">
                - {{ register.info.status }}</span
              >
            </div>
            <div class="value">{{ register.info.name.value }}</div>
          </div>
          <div v-if="register.actions.filter((v) => !v.disabled).length">
            <div class="dropdown">
              <button
                class="btn bg-white text-muted dropdown-toggle"
                type="button"
                data-toggle="dropdown"
              >
                <span class="material-icons"> edit </span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <router-link
                  class="dropdown-item"
                  :to="action.link"
                  v-for="(action, i) in register.actions.filter(
                    (v) => v.link && !v.disabled
                  )"
                  :key="i"
                >
                  {{ action.label }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="label">CPF</div>
          <div class="value">{{ register.info.document.value }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Plano</div>
          <div class="value">{{ register.info.plano.value }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Acomodação</div>
          <div class="value">{{ register.info.acomodacao.value }}</div>
        </div>
        <div class="mt-3" v-if="register.info.opcionais.value">
          <div class="label">Opcionais</div>
          <div class="value">{{ register.info.opcionais.value }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Valor unitário</div>
          <div class="value">{{ register.info.preco.value | currency }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ListaCadastrosPlano",
  props: {
    plan: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    acao(action, id) {
      this.$emit(action, id);
    },
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 6px;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.dropdown {
  position: relative;
  margin-right: -16px;
}
</style>
